module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "heading_id_2",
      "title": "Contents"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/intro"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("1")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "#/Text/1"
    }
  }, [_vm._v("A Modern Boat for an Ancient Voyage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("2")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ancient Olive Groves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("3")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searching for Wild Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("4")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Ancient Food for Modern Foodies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("5")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coveting Virginity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("6")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illumination and Inspiration on the French Riviera")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("7")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ancient Civilizations, Ancient Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("8")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Science of Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("9")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Live Like a Centenarian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("10")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Olive Solution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("11")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Something Old and Something New")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("12")]), _vm._v(" | "), _c('span', {
    attrs: {
      "href": "#/Text/12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birthplace of the Olive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ref",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appa",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("APPENDIX A")]), _vm._v(": Tips on Hosting an Olive Oil Tasting Party")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appb",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("APPENDIX B")]), _vm._v(": Top Questions about Olive Oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appc",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("APPENDIX C")]), _vm._v(": Olive Oil and Olive Recipes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_serif"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/photosection",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Photo Section")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eda95748","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 69
// module chunks = 0